import * as ENDPOINTS from '@/common/constants/endpoints'
import { shouldInsertAccount } from '@/utils/account'

import { api } from '../api'

export const getConsortium = async ({ account, accountType }: DefaultHeader) =>
  api<Consortium>(ENDPOINTS.CONSORTIUM, {
    method: 'GET',
    headers: {
      'account-type': accountType,
      ...shouldInsertAccount({ accountType, account }),
    },
  })
